import React, {useState} from 'react';
import {Content, Container} from 'app/components/matchEvents/MatchEventStyles';
import {Image} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {FullscreenImage} from 'app/components/backdrop/FullscreenImage';
import {defaultSpace, desktopContentWidth} from 'app/styles/media';
import MatchEventMinute from 'app/components/matchEvents/MatchEventMinute';

const percentWidth = 92;
const maxImageWidth = desktopContentWidth - defaultSpace;

const ImageContainer = styled.div`
  display: flex;
  // Aspect Ratio 16:9
  flex: 1 ${percentWidth}%;
  width: ${percentWidth}vw;
  height: ${(percentWidth * 9) / 16}vw;
  cursor: pointer;
  ${props => props.theme.desktopLayout`
    max-width: ${maxImageWidth * 0.75}px;
    max-height: ${(maxImageWidth * 0.75 * 9) / 16}px;
  `}
`;

const MatchEventPhoto = ({event}) => {
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;
  const [fullscreen, setFullscreen] = useState(null);

  if (!event.image) {
    return null;
  }

  const handleOpen = () => {
    setFullscreen(true);
  };

  const handleClose = () => {
    setFullscreen(null);
  };

  return (
    <>
      <Content noContentPadding>
        <Container>
          <MatchEventMinute minute={time} />
          <ImageContainer onClick={handleOpen}>
            <Image
              sizesHint={`(max-width: ${desktopContentWidth}px) ${percentWidth}vw, ${maxImageWidth}px}`}
              entity='match-event'
              actualWidthFactor={1}
              ratio='16:9'
              src={event.image}
            />
          </ImageContainer>
        </Container>
      </Content>
      <FullscreenImage entity='match-event' imageSrc={event.image} onClick={handleClose} open={!!fullscreen} />
    </>
  );
};

export default MatchEventPhoto;
